<div class="catalog-subcategories" data-test="catalog-subcategories-wrapper">
  <agr-chips-filter
    data-test="catalog-subcategories-filter"
    [items]="displayedSubcategories$ | async"
    (change)="selectSubcategory($event)"
    [multiple]="false"
    [hideClear]="true"
    *ngIf="(displayedSubcategories$ | async)?.length"
  ></agr-chips-filter>

  <div class="flex flex--justify-flex-end">
    <button mat-button data-test="subcatalog__showMore" *ngIf="shouldShowMoreButton$ | async" (click)="toggleShowMoreSubcategories()">
      <span>
        {{ ((showMoreToggle$ | async) ? 'show_less' : 'show_more') | translate }}
      </span>
      <mat-icon class="">{{ (showMoreToggle$ | async) ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </div>
</div>
